var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.25C12.1381 3.25 12.25 3.36192 12.25 3.5V15.41C12.25 15.5481 12.1381 15.66 12 15.66C11.8619 15.66 11.75 15.5481 11.75 15.41V3.5C11.75 3.36192 11.8619 3.25 12 3.25Z",
    fill: "#007AAF",
    stroke: "#007AAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22651 11.823L8.2265 11.823C8.12878 11.7255 7.97054 11.7257 7.87302 11.8234L8.22651 11.823ZM8.22651 11.823L11.6469 15.234L12 15.5861M8.22651 11.823L12 15.5861M12 15.5861L12.3531 15.234M12 15.5861L12.3531 15.234M12.3531 15.234L15.7735 11.823L15.7735 11.823M12.3531 15.234L15.7735 11.823M15.7735 11.823C15.8712 11.7255 16.0295 11.7257 16.127 11.8234L15.7735 11.823ZM12.5141 15.7796L16.1265 12.177C16.2243 12.0796 16.2245 11.9213 16.127 11.8235L12.5141 15.7796ZM12.5141 15.7796L12.5139 15.7797L12.4572 15.8363L12.4568 15.8367C12.4568 15.8367 12.4568 15.8367 12.4568 15.8368C12.4568 15.8368 12.4568 15.8368 12.4567 15.8368C12.2079 16.0854 11.8038 16.0813 11.549 15.8424L11.5488 15.8421L11.544 15.8375L11.5435 15.837L7.87348 12.177C7.87348 12.177 7.87347 12.177 7.87347 12.177C7.77573 12.0795 7.77548 11.9213 7.87298 11.8235L12.5141 15.7796Z",
    fill: "#007AAF",
    stroke: "#007AAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 15.0293C3.41422 15.0293 3.75 15.3651 3.75 15.7793V17.6693C3.75 18.8134 4.68249 19.7493 5.84 19.7493H18.16C19.3175 19.7493 20.25 18.8134 20.25 17.6693V15.7793C20.25 15.3651 20.5858 15.0293 21 15.0293C21.4142 15.0293 21.75 15.3651 21.75 15.7793V17.6693C21.75 19.6452 20.1425 21.2493 18.16 21.2493H5.84C3.8575 21.2493 2.25 19.6452 2.25 17.6693V15.7793C2.25 15.3651 2.58578 15.0293 3 15.0293Z",
    fill: "#007AAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.572f217951c85b878b0d0cf0aaea840e.svg";
export { ForwardRef as ReactComponent };